import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';
import theme from './theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PlatformHero from './components/platform/PlatformHero';
import PlatformDeliverables from './components/platform/PlatformDeliverables';
import PlatformAIStack from './components/platform/PlatformAIStack';
import PlatformCustomCards from './components/platform/PlatformCustomCards';
import CtaBanner from './components/home/CtaBanner';
import CustomCursor from './components/home/CustomCursor';
import { useCapability } from './components/home/three/useCapability';

const JSON_LD_ID = 'platform-page-jsonld';

// Route-specific structured data — same pattern as Method.jsx: index.html
// carries only site-wide JSON-LD, so this page injects its own block on
// mount and removes it on unmount.
function usePlatformJsonLd() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = JSON_LD_ID;
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'La piattaforma Sinergie Generative: cosa sblocca il libro',
      description: 'Dashboard col mentor AI, brief scaricabile, carte concettuali, sessioni solo o di gruppo, note integrabili e carte su misura su richiesta.',
      url: 'https://aicards.ai/piattaforma',
      inLanguage: 'it-IT',
      about: [
        'Retrieval-Augmented Generation modulare',
        'modelli linguistici in locale, adattivi tra CPU e GPU',
        'routing di intento',
        'pipeline ad agenti a più passi',
        'mentor multi-motore con continuità di servizio (cloud, locale, chiave propria)',
        'architettura privacy-by-design',
        'agentic coding copilot',
      ],
      isPartOf: { '@type': 'WebSite', name: 'Sinergie Generative', url: 'https://aicards.ai/' },
    });
    document.head.appendChild(script);
    return () => { script.remove(); };
  }, []);
}

function Platform() {
  usePlatformJsonLd();
  const capability = useCapability();

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{
        bgcolor: theme.home.paper, color: theme.home.ink,
        ...(capability.renderCursor ? { cursor: 'none', '& *': { cursor: 'none !important' } } : {}),
      }}>
        {capability.renderCursor && <CustomCursor />}
        <Navbar />
        <PlatformHero />
        <PlatformDeliverables />
        <PlatformAIStack />
        <PlatformCustomCards />
        <CtaBanner />
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default Platform;
